import React, { useEffect, useState, useMemo } from "react";
import Cookies from 'js-cookie';
import { useParams, useHistory } from "react-router-dom"
import { FaSearch, FaCopy, FaMapMarkerAlt, FaTimes, FaCircle, FaClock, FaTicketAlt, FaFilter } from "react-icons/fa"
import "./event_calender.css"
import { showToast, ToastMessage } from "../Shared/ToastMessage"
import axios from "axios"
import { localserver, commonBaseUrl } from "../../api/common"
import Header from "./Header"
import Footer from "./Footer"
import { decryptSlug, encryptSlug } from "../../util/encryption"

export default function UserEventsPage() {
  const { id } = useParams()
  const history = useHistory()
  const decryptedId = decryptSlug(id)
  const [events, setEvents] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [getEventStatus, setGetEventStatus] = useState(false)
  const [hasLoaded, setHasLoaded] = useState(false)
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return {
      day: date.getDate(),
      month: date.toLocaleDateString("en-US", { month: "short" }),
      fullDate: date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      time: date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
      fullDateTime: date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    }
  }
  const filteredEvents = useMemo(() => {
    if (!searchQuery.trim()) {
      return events
    }
    const searchTerm = searchQuery.toLowerCase()
    return events.filter(
      (event) =>
        (event.event_name || "").toLowerCase().includes(searchTerm) ||
        (event.venue_city || "").toLowerCase().includes(searchTerm) ||
        (event.venue_state || "").toLowerCase().includes(searchTerm) ||
        (event.description || "").toLowerCase().includes(searchTerm) ||
        (event.event_type || "").toLowerCase().includes(searchTerm) ||
        (event.tags || "").toLowerCase().includes(searchTerm),
    )
  }, [events, searchQuery])
  const handleSearch = (value) => {
    setSearchQuery(value)
  }
  const eventsToShow = filteredEvents
  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href)
    showToast("Link copied to clipboard!", "success")
  }
  const getEventByUser = async () => {
    if (!decryptedId) {
      showToast("Invalid user ID", "error")
      return
    }
    try {
      setGetEventStatus(true)
      const response = await axios.post(
        `${localserver}/get_register_event_ByUser`,
        { email: decryptedId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      if (response.data.success) {
        setEvents(response.data.data || [])
      } else {
        console.error("Error: Failed to fetch user data")
        showToast("Failed to fetch events", "error")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
      showToast("An error occurred while fetching events", "error")
    } finally {
      setGetEventStatus(false)
    }
  }
  useEffect(() => {
    if(decryptedId!==null && !hasLoaded){
      setHasLoaded(true);
      fetchProfileMenuDetails();
      getEventByUser()
    }
  }, [decryptedId, hasLoaded])
  const fetchProfileMenuDetails = async () => {
    try {
      const response = await axios.post(
        `${commonBaseUrl}/api/check_user_data`,
        {
          username: decryptedId
        },
        {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        const user = response.data.data[0];
        const eventUser = response.data.event_data[0];
        const isMember= response.data.member;
        const isEventMember= response.data.event;
        localStorage.setItem('isMember', isMember);
        localStorage.setItem("isEventMember", isEventMember);
        if(isEventMember===1){
            // Store user details
            Cookies.set("eventMemberUserId", response.data.event_data[0].id, { expires: 1 });
            localStorage.setItem("loginEventMemberUserId", response.data.event_data[0].id);
            const fullName = `${eventUser.first_name}${eventUser.last_name ? ' ' + eventUser.last_name : ''}`;
            localStorage.setItem('loginEventMemberUserName', fullName);
            localStorage.setItem("loginEventMemberEmail", eventUser.email);
        }
        if(isMember===1){
          // Cookies.set("memberUserId", response.data.data[0].id, { expires: 1 });
          localStorage.setItem("loginMemberUserId", response.data.data[0].id);
          const fullName = `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}`;
          localStorage.setItem('loginEventMemberUserName', fullName);
          localStorage.setItem("loginEventMemberEmail", user.email);
        }
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };
  return (
    <div>
      <Header />
    <div className="event_priciew_calender pt-5">
      <div className="enhanced-user-events">
        <ToastMessage />
        {/* Enhanced Header Section */}
        <div className="header-section">
          <div className="header-container">
            <div className="header-content">
              <div className="header-icon-wrapper">
                <div className="header-icon">
                  <FaTicketAlt className="icon" />
                </div>
              </div>
              <div className="header-text">
                <h1 className="header-title">My Events</h1>
                <p className="header-subtitle">Your registered events</p>
              </div>
            </div>
            {/* <button onClick={copyLink} className="share-btn">
              <FaCopy className="share-icon" />
              <span>Share</span>
            </button> */}
          </div>
        </div>
        <div className="main-container">
          {getEventStatus ? (
            <div className="loading-container">
              <div className="loading-content">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading events...</p>
              </div>
            </div>
          ) : (
            <>
              {/* Enhanced Search Section */}
              <div className="search-container">
                <div className="search-content">
                  <div className="search-wrapper">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Search events..."
                      value={searchQuery}
                      onChange={(e) => handleSearch(e.target.value)}
                      className="search-input"
                    />
                    {searchQuery && (
                      <button onClick={() => setSearchQuery("")} className="clear-btn">
                        <FaTimes />
                      </button>
                    )}
                  </div>
                  <div className="search-actions">
                    {/* <button className="filter-btn">
                      <FaFilter />
                      Filter
                    </button> */}
                    <div className="event-count">
                      <span>{eventsToShow.length} events</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Enhanced Events Grid */}
              <div className="events-grid">
                {eventsToShow.length > 0 ? (
                  eventsToShow.map((event) => (
                    <div key={event.id} className="event-card-enhanced">
                      {/* Event Header */}
                      <div className="event-header-enhanced">
                        <div className="event-date-info">
                          <div className="date-badge-enhanced">
                            {formatDate(event.start_date).month} '
                            {formatDate(event.start_date).day.toString().slice(-2)}
                          </div>
                          <div className="date-day-enhanced">{formatDate(event.start_date).day}</div>
                        </div>
                        <div className="event-logo-wrapper">
                          <img
                            src={event.event_logo}
                            alt="Event logo"
                            className="event-logo-enhanced"
                            // onError={(e) => {
                            // e.target.src = "/placeholder.svg"
                            // }}
                          />
                          {event.event_status === "live" && (
                            <div className="live-indicator">
                              <FaCircle className="live-pulse" />
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Event Content */}
                      <div className="event-content-enhanced">
                        <div className="event-info">
                          <h3 className="event-title-enhanced">{event.event_name}</h3>
                          <span className="event-type-badge">{event.event_type}</span>
                        </div>
                        <div className="event-meta-enhanced">
                          <div className="meta-item-enhanced">
                            <FaMapMarkerAlt className="meta-icon location-icon" />
                            <span className="meta-text">
                              {event.venue_city}, {event.state_name}
                            </span>
                          </div>
                          <div className="meta-item-enhanced">
                            <FaClock className="meta-icon time-icon" />
                            <span className="meta-text">
                              {event.start_time} - {event.end_time}
                            </span>
                          </div>
                        </div>
                        <button
                          className="ticket-btn-enhanced"
                          onClick={() => {
                            history.push(`/events/user-event-details/${id}/${encryptSlug(`${event.id}`)}`)
                          }}
                        >
                          <FaTicketAlt className="ticket-icon" />
                          View Ticket
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-events-enhanced">
                    <div className="no-events-content">
                      <div className="no-events-icon">
                        <FaTicketAlt />
                      </div>
                      <h3 className="no-events-title">No Events Found</h3>
                      <p className="no-events-text">
                        {searchQuery ? `No events match "${searchQuery}"` : "You haven't registered for any events yet"}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
    </div>
  )
}